(function ($) {
    'use strict'

    if (window.location.href.indexOf("my-account/subscriptions") === -1) {
        // only run this on the appropriate page
        return;
    }

    $(window).load(function () {


        // enable subscription management buttons now that page load has completed
        $('.button-subscription-management').removeAttr("disabled")

        // allows packages to be changed within a subscription
        $(".choose-plan-button").click(async function () {
            let popup = document.querySelector('.package-change-popup');
            let subscriptionId = this.dataset.subscriptionId;
            let planId = this.dataset.planId;
            let addonId = this.dataset.addonId;

            window.utils.forms.removeErrorMessage(popup);
            window.utils.animations.addLoadingSpinner(document.querySelector('body'))

            const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${subscriptionId}/upgrade`, {
                plan_id: planId,
                addon_id: addonId,
            })

            let responseObj = JSON.parse(responseJson)
            if (responseObj.success) {
                location.reload()
            } else {
                console.error(responseObj);
                window.utils.forms.addErrorMessage('Could not switch subscription, please try again or contact dermteam@klira.skin', popup);
                window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
            }
        })

        $(".button-resume-subscription").click(async function () {
            const subId = $(this).data("subscription-id")
            const checkoutUrl = $(this).data("checkout-url")
            window.utils.animations.addLoadingSpinner(document.querySelector('body'))

            try {
                const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${subId}/resume`)
                let responseObj = JSON.parse(responseJson)

                if (responseObj.success) {
                    location.reload()
                } else if (responseObj.redirect) {
                    window.location.href = responseObj.redirect
                } else {
                    console.error(responseObj);
                    window.utils.forms.addErrorMessage('Could not resume subscription, please try again or contact dermteam@klira.skin', this);
                    window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
                }
            } catch (e) {
                console.error(e);
                if (checkoutUrl) {
                    window.location.href = checkoutUrl
                } else {
                    window.utils.forms.addErrorMessage('Could not resume subscription, please try again or contact dermteam@klira.skin', this);
                    window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
                }
            }
        })







        // EVENT LISTENERS

        // Subscription cancellation - store subscription ID when popup opens
        let cancelSubscriptionId = null;
        document.addEventListener(
            'click',
            function(event) {
                if (!event.target.matches('.subscription-cancellation-button')) {
                    return;
                }
                cancelSubscriptionId = event.target.dataset.subscriptionId;
            }
        )

        // Subscription cancellation - confirm click
        document.addEventListener(
            'click',
            async function(event) {
                if (!event.target.matches('#retention-confirm-subscription-cancellation')) {
                    return;
                }

                if (!cancelSubscriptionId) {
                    console.error("SUBSCRIPTION: No subscription ID set for cancellation");
                    return;
                }

                const popup = document.querySelector('.subscription-cancellation-popup');
                window.utils.forms.removeErrorMessage(popup);
                window.utils.animations.addLoadingSpinner(document.querySelector('body'));

                const reasonRadio = popup.querySelector('input[name="reason-leaving"]:checked');
                const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${cancelSubscriptionId}/cancel`, {
                    retention_reason_for_leaving: reasonRadio ? reasonRadio.value : null,
                    retention_leaving_text: popup.querySelector('.reason-leaving-other').value || null,
                    retention_will_resubscribe: popup.querySelector('input[name="resubscribe-likelihood-rating"]:checked')?.value || null,
                    retention_experience: popup.querySelector('.share-experience-input').value || null,
                });

                let responseObj = JSON.parse(responseJson);
                if (responseObj.success) {
                    location.reload();
                } else {
                    console.error(responseObj);
                    window.utils.forms.addErrorMessage('Could not cancel subscription, please try again or contact dermteam@klira.skin', popup);
                    window.utils.animations.removeLoadingSpinner(document.querySelector('body'));
                }
            }
        )

        // Skip a month - modal open
        document.addEventListener(
            'click',
            function(event) {
                if (!event.target.matches('.skip-a-month-button')) {
                    return;
                }

                console.log("SUBSCRIPTION: Opened skip a month popup");

                let subscriptionId = event.target.dataset.subscriptionId;
                let nextOrderDate = event.target.dataset.nextOrderDate;
                let newOrderDate = event.target.dataset.newOrderDate;

                const skipAMonthPopup = document.querySelector('.skip-a-month-popup');
                const nextOrderDateEle = skipAMonthPopup.querySelector('.next-order-date');
                const newOrderDateEle = skipAMonthPopup.querySelector('.new-order-date');
                nextOrderDateEle.innerHTML = nextOrderDate;
                newOrderDateEle.innerHTML = newOrderDate;

                if (!subscriptionId) {
                    console.error("SUBSCRIPTION: No subscription ID could be found");
                    return;
                }

                // set the subscription ID
                window.subscriptions.setSubscriptionId(subscriptionId);
            }
        )

        // Skip a month - confirm click
        document.addEventListener(
            'click',
            async function(event) {
                if (!event.target.matches('.confirm-skip-a-month-button')) {
                    return;
                }

                window.utils.forms.removeErrorMessage(event.target);

                window.utils.animations.addLoadingSpinner(document.querySelector('body'));

                let response = await window.subscriptions.skipAMonth.skip()

                if (response.success) {
                    window.location.href = "/my-account/subscriptions/"
                } else {
                    console.log(response);
                    window.utils.forms.addErrorMessage(response.message, event.target);
                    window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
                }
            }
        )


        // FUNCTIONS
    })
})(jQuery)